import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=6b9f5fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9f5fca"]])

export default __exports__